import { IsEnum, IsString } from 'class-validator';

export enum SortDirection {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export class SortInput {
  @IsString()
  public name: string;

  @IsEnum(SortDirection)
  public direction: SortDirection;

  constructor(inputString: string) {
    [this.name, this.direction] = inputString.split('-') as [string, SortDirection];
  }
}
